import { Injectable, inject } from '@angular/core';
import {
    UserPositionDto,
    UserPositionExitCleanupTask,
} from '@pf/platform-core/domain';
import { AuditDataService } from '@pf/platform-wms/domain';
import { asArraySafe } from '@pf/shared-utility';
import { Observable, of } from 'rxjs';
import { CycleCountContext } from '../../models/cycle-count-context.model';
import { CpwUserPositionTypes } from '../../UserPositionTypes';

type CycleCountContextWithWarehouse = CycleCountContext & {
    warehouseId?: string;
};

@Injectable({ providedIn: 'root' })
export class CycleCountPositionExitCleanupTask
    implements UserPositionExitCleanupTask
{
    readonly id = 'cycle-count-release-audits';

    private readonly auditDataService = inject(AuditDataService);

    appliesTo(position: UserPositionDto): boolean {
        if (
            position.userPositionTypeName !== CpwUserPositionTypes.CycleCounts
        ) {
            return false;
        }
        const ctx = position.context as
            | CycleCountContextWithWarehouse
            | undefined;
        return !!asArraySafe(ctx?.auditIds).length && !!ctx?.warehouseId;
    }

    cleanup$(position: UserPositionDto): Observable<unknown> {
        const ctx = position.context as
            | CycleCountContextWithWarehouse
            | undefined;
        const warehouseId = ctx?.warehouseId;
        const auditIds = asArraySafe(ctx?.auditIds);
        if (!warehouseId || !auditIds.length) return of(null);
        return this.auditDataService.releaseAudits$(warehouseId, auditIds);
    }
}
